<template>
  <LangDropdown
    v-model="model"
    lang-code-key="iso_code"
    id-key="language_profile_id"
    :options="options"
    :disabled="isLoading"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { defaultLang as defaultLangCode } from "@shared/plugins/i18n";

import LangDropdown from "@shared/components/LangDropdown";
import { EventBus } from "@/main.js";

const defaultLangData = {
  language_profile_id: "default",
  name: "English",
}

export default {
  name: "language-menu",  
  components: {
    LangDropdown,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      currentLangProfile: "LocalizationStore/getCurrentLangProfile",
      langProfileOptions: "LocalizationStore/getUserLangProfileList",
    }),

    defaultLang() {
      return this.langProfileOptions.find((el) => el.code === defaultLangCode) ?? defaultLangData;
    },

    model: {
      get() {
        // eslint-disable-next-line no-unused-vars
        const { icon, ...value } = (this.currentLangProfile || this.defaultLang);
        return value;
      },
      set(val) {
        this.changeLang(val);
      }
    },

    // TODO add flag icons
    options() {
      return this.langProfileOptions;
    },
  },

  methods: {
    ...mapActions({
      updateUserLangProfile: "LocalizationStore/updateUserLangProfile",
    }),

    async changeLang(langProfile) {
  
      if (!langProfile.language_profile_id) return;
      this.isLoading = true;
      try {
        await this.updateUserLangProfile(langProfile);
        this.$emit("changeLanguage")
        EventBus.$emit("changeLanguageProfile", null);
        // this.$toast.success(response?.message || this.$t("general.update_success"));
      } catch (error) {
        console.error("Error while changing language profile", error);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>